import styled from 'styled-components';

export const Column = styled.th`
  display: flex;
  flex: 1;
`;
